import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {KnownTrigger, TriggerSpecification} from "types/Trigger";
import deserializeTrigger from "services/ngage/deserializers/trigger";

/**
 * Get all triggers (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<KnownTrigger> | null>(`/triggers?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeTrigger)
    }

    return response.data
}

/**
 * Get a single trigger
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<KnownTrigger | null>(`/triggers/${id}`)
    return response.data? deserializeTrigger(response.data) : null
}

/**
 * Update an existing trigger
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: TriggerSpecification) => {
    const response = await client.put<KnownTrigger | null>(`/triggers/${id}`, data)
    return response.data? deserializeTrigger(response.data) : null
}

/**
 * Store a new trigger
 *
 * @param data
 */
const store = async (data: TriggerSpecification) => {
    const response = await client.post<KnownTrigger | null>('/triggers', data)
    return response.data? deserializeTrigger(response.data) : null
}

/**
 * Permanently delete a trigger
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/triggers/${id}`)
    return response.status === 204
}

const triggers = {
    all,
    get,
    store,
    update,
    destroy
}

export default triggers;